import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EntityServiceError } from '../shared/errors/entity-service.error';
import { AdminOrganizationSubscription } from './models/admin-organization-subscription.model';

export const AdminOrganizationSubscriptionComponentActions = createActionGroup({
  source: 'Admin Organization Subscription Component',
  events: {
    Initialized: props<{ id: number }>(),
    Exited: emptyProps(),
    'Save Subscription Clicked': props<{ id: number; stripeSubscriptionId: string }>(),
  },
});

export const AdminOrganizationSubscriptionEffectActions = createActionGroup({
  source: 'Admin Organization Subscription Effect',
  events: {
    'Get Subscription Succeeded': props<{ subscription: AdminOrganizationSubscription }>(),
    'Get Subscription Errored': props<{ error: EntityServiceError }>(),
    'Update Subscription Succeeded': props<{ id: number }>(),
    'Update Subscription Errored': props<{ error: EntityServiceError }>(),
  },
});
